import type { FC } from 'react';
import { Skeleton } from '@/components/ui/skeleton';

export const SignalSkeleton: FC = () => (
  <div className="flex flex-col gap-3" data-testid="signal-skeleton">
    <Skeleton className="h-20 rounded-xl" />
    <Skeleton className="h-20 rounded-xl" />
    <Skeleton className="h-20 rounded-xl" />
  </div>
);
